import React, { useState } from "react";
import useApi from "../../Hooks/useApi";
import * as postapi from "../../api/postapi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Col, Form, Row } from "react-bootstrap";
import customloader from "../../assets/images/RollingLoader.gif";

const PayNowModal = ({ toggle, close, data }) => {
  const [validated, setValidated] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paidAmount, setPaidAmount] = useState();
  const [transDate, setTransDate] = useState(new Date().toISOString().split("T")[0]);
  const [transactionId, settransactionId] = useState();
  const [paidCheck, setPaidCheck] = useState(false);
  //   const [show, setShow] = useState(false);
  const [selectImage, setSelectImag] = useState();
  const [selectImageURL, setSelectImagURL] = useState({
    url: "",
    type: "file",
  });
  const { user } = useSelector((state) => state.auth);
  const [isClicked, setIsClicked] = useState(false);
  const imageUpload = useApi(postapi.UploadProof);

  const handlePaymentSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsClicked(true);
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
      }
      setValidated(true);
      if (data.shop_name && data.settlement_type && paidAmount && paymentType === "transfer" && transactionId && transDate && selectImageURL) {
        if (+paidAmount !== Math.round(data.sum_net_amount)) {
          setIsClicked(false);
          setPaidCheck(true);
        } else {
          let imgData;
          setValidated(true);
          if (selectImage) {
            imgData = await imageUpload.request(selectImage);
          }

          const [date, time] = new Date().toISOString().split("T");
          const curDate = date.split("-");
          const curTime = time.split(".")[0].replaceAll(":", "");
          const dateB32 = Number(curDate[2] + curDate[1] + curDate[0])
            .toString(32)
            .toUpperCase();
          const timeB32 = Number(curTime).toString(32).toUpperCase();
          const dateNow = new Date().toISOString().split("T")[0];
          const timeNow = new Date().toLocaleTimeString().split(" ")[0];
          const currentDate = dateNow + " " + timeNow;

          const paymentIds = [];
          const ids = data?.orders_details?.map((item) => paymentIds.push(item.id));
          let obj = {};
          obj = {
            paymentIds,
            payment_proof: imgData && imgData.data.files[0],
            transaction_date: transDate ? transDate : currentDate,
            payment_transaction_id: transactionId ? transactionId : data?.group_id + user.user_id + dateB32 + timeB32,
          };
          const res = await postapi.processSellerPayments(obj);
          if (res) {
            toast.success("Payment Successful", {
              position: "bottom-right",
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setIsClicked(false);
            setValidated(false);
            close();
            toggle((prev) => !prev);
          }
        }
      } else {
        setIsClicked(false);
      }
    } catch (error) {
      setIsClicked(false);
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("files", e.target.files[0], e.target.files[0].name);
    setSelectImag(formData);
    setSelectImagURL({ url: URL.createObjectURL(e.target.files[0]), type: "file" });
  };
  return (
    <>
      <Form noValidate validated={validated} onSubmit={handlePaymentSubmit}>
        <Row>
          <>
            <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12">
              <label>
                Shop Name<span className="text-danger">*</span>
              </label>
              <Form.Control className="p-2 text-capitalize" name="province" placeholder="Plan" type="text" value={data?.shop_name} onChange={() => {}} required disabled />
            </Form.Group>
            <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="price">
              <label>
                Amount Payable <span className="text-danger">*</span>
              </label>
              <Form.Control value={Math.round(data?.sum_net_amount)} type="number" placeholder="Rs.1000" disabled />
            </Form.Group>
            <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
              <label>Settlement Type</label>
              <Form.Control value={data?.settlement_type} disabled />
              <Form.Control.Feedback type="invalid">Please Select Settlement Type</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
              <label>Payment Type</label>
              <Form.Select
                onChange={(e) => {
                  setPaymentType(e.target.value);
                }}
                value={paymentType}
                required
              >
                <option value="" selected disabled>
                  Select Payment Type
                </option>
                <option value="transfer">Transfer</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">Please Select Payment Type</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
              <label>
                Transaction Id <span className="text-danger">*</span>
              </label>
              <Form.Control
                value={transactionId}
                name="transaction_id"
                onChange={(e) => {
                  settransactionId(e.target.value);
                }}
                placeholder="eg.AA11"
                required={paymentType === "transfer" ? true : false}
              />
              <Form.Control.Feedback type="invalid">Please Enter Transaction Id.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
              <label>
                Transaction Date<span className="text-danger">*</span>
              </label>
              <Form.Control value={transDate} name="trans_date" disabled={true} required={paymentType === "transfer" ? true : false} type="date" />

              <Form.Control.Feedback type="invalid">Please select Date.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="price">
              <label>
                Paid Amount <span className="text-danger">*</span>
              </label>
              <Form.Control
                value={paidAmount ? paidAmount : ""}
                placeholder="Rs.1000"
                required
                onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                min={Math.round(data?.sum_net_amount)}
                max={Math.round(data?.sum_net_amount)}
                onChange={(e) => {
                  if (Number(e.target.value) > 0) {
                    setPaidAmount(e.target.value);
                    if (Math.round(data?.sum_net_amount) === Number(e.target.value)) {
                      setPaidCheck(false);
                    } else {
                      setPaidCheck(true);
                    }
                  } else {
                    setPaidAmount(0);
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">Please Enter Amount</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="6" controlId="formBasicShopName">
              <label className="mb-1">
                Upload Image<span className="text-danger">*</span>
              </label>
              <Form.Control type="file" size="sm" accept="image/*" name="contact_person_name" onChange={(e) => handleImageUpload(e)} required={paymentType === "transfer" ? true : false} />
              <Form.Control.Feedback type="invalid">Please upload image.</Form.Control.Feedback>
            </Form.Group>
            <div className="mt-2 d-flex align-items-center justify-content-center w-100 ">
              <div style={{ width: "150px" }}>
                <img src={selectImageURL.url} alt="" width="100%" height="auto" />
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <Button className="w-25 mt-3" type="submit" disabled={isClicked}>
                Log
              </Button>
            </div>
            {paidCheck && (
              <div class="alert alert-danger  text-center w-100 mt-2" role="alert">
                Paid amount must be equal to payable
              </div>
            )}
          </>
        </Row>
      </Form>
    </>
  );
};

export default PayNowModal;
